import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { apiWithUrlParams } from '../apiMiddleware/apiMiddleware';
import * as types from '../constants';

function* getDayCalendar(action) {
  const urlParams = {
    day: action.day,
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  const currentDay = action.day;
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCalendar', urlParams);
    yield put({
      type: types.GET_DAY_CALENDAR_SUCCESS, data, currentDay, widgetId: action.widgetId,
    });
  } catch (error) {
    yield put({ type: types.GET_DAY_CALENDAR_ERROR, error });
  }
}

function* getCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendar', urlParams);
    yield put({ type: types.GET_CALENDAR_SUCCESS, data, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_CALENDAR_ERROR, error });
  }
}

function* getDayCalendarCorriere(action) {
  const urlParams = {
    day: action.day,
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  const currentDay = action.day;
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCalendar', urlParams);
    yield put({
      type: types.GET_DAY_CALENDAR_CORRIERE_SUCCESS, data, currentDay, widgetId: action.widgetId,
    });
  } catch (error) {
    yield put({ type: types.GET_DAY_CALENDAR_CORRIERE_ERROR, error });
  }
}

function* getCalendarCorriere(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendar', urlParams);
    yield put({ type: types.GET_CALENDAR_CORRIERE_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_CALENDAR_CORRIERE_ERROR, error });
  }
}

function* getGazzanetCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    isWidget: action.isWidget,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendar', urlParams);
    yield put({ type: types.GET_CALENDAR_GAZZANET_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_CALENDAR_GAZZANET_ERROR, error });
  }
}

function* getDayCupCalendarCorriere(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    phase: action.phase,
    subPhase: action.subphase,
    seasonId: action.seasonId,
    isWidget: action.isWidget,
  };

  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
    yield put({ type: types.GET_DAY_CUP_CALENDAR_CORRIERE_SUCCESS, data, urlParams });
  } catch (error) {
    yield put({ type: types.GET_DAY_CUP_CALENDAR_CORRIERE_ERROR, error });
  }
}

function* getCupCalendarCorriere(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
    isWidget: action.isWidget,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCalendarWidgetCorriere', urlParams);
    yield put({ type: types.GET_CUP_CALENDAR_CORRIERE_SUCCESS, data, urlParams });
  } catch (error) {
    yield put({ type: types.GET_CUP_CALENDAR_CORRIERE_ERROR, error });
  }
}

function* getTeamCalendar(action) {
  const urlParams = {
    sportId: action.sportId,
    teamId: action.teamId,
    seasonId: action.seasonId,
    isWidget: action.isWidget,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'widgets', 'getTeamCalendar', urlParams);
    yield put({ type: types.GET_TEAM_CALENDAR_SUCCESS, data, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_TEAM_CALENDAR_ERROR, error });
  }
}

function* getRugbyTabbar(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    seasonId: action.seasonId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'calendar', 'getCupTabbar', urlParams);
    if (action.phase) {
      urlParams.phase = action.phase;
    }
    if (action.subPhase) {
      urlParams.subPhase = action.subPhase;
    }
    yield put({
      type: types.GET_RUGBY_TABBAR_SUCCESS, data, urlParams, widgetId: action.widgetId,
    });
  } catch (error) {
    yield put({ type: types.GET_RUGBY_TABBAR_ERROR, error });
  }
}

function* getRugbyCalendar(action) {
  const { urlParams } = action;
  if (typeof urlParams.phase === 'undefined' && typeof urlParams.subPhase === 'undefined') {
    urlParams.phase = action.data.lastPhase.label;
    urlParams.subPhase = action.data.lastSubPhase;
  }
  if (urlParams.phase && urlParams.phase === 'regularSeason') {
    urlParams.subPhase = '';
  }
  const isNumber = !Number.isNaN(Number(urlParams.phase));
  try {
    if (isNumber) {
      yield put({
        type: types.GET_DAY_CALENDAR_REQUEST,
        sportId: action.urlParams.sportId,
        competitionId: action.urlParams.competitionId,
        widgetId: action.widgetId,
        day: Number(action.urlParams.phase),
      });
    } else {
      const { data } = yield call(apiWithUrlParams, 'calendar', 'getDayCupCalendar', urlParams);
      yield put({ type: types.GET_RUGBY_CALENDAR_SUCCESS, data, widgetId: action.widgetId });
    }
  } catch (error) {
    yield put({ type: types.GET_RUGBY_CALENDAR_ERROR, error });
  }
}

function* getRugbyCalendarWithPhase(action) {
  action.urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    phase: action.phase,
    subPhase: action.subPhase,
  };
  yield getRugbyCalendar(action);
}

function* watchGetDayCalendar() {
  yield takeEvery(types.GET_DAY_CALENDAR_REQUEST, getDayCalendar);
}

function* watchGetCalendar() {
  yield takeEvery(types.GET_CALENDAR_REQUEST, getCalendar);
}

function* watchGetCalendarCorriere() {
  yield takeLatest(types.GET_CALENDAR_CORRIERE_REQUEST, getCalendarCorriere);
}

function* watchGetDayCalendarCorriere() {
  yield takeLatest(types.GET_DAY_CALENDAR_CORRIERE_REQUEST, getDayCalendarCorriere);
}

function* watchGetCupCalendarCorriere() {
  yield takeLatest(types.GET_CUP_CALENDAR_CORRIERE_REQUEST, getCupCalendarCorriere);
}

function* watchGetDayCupCalendarCorriere() {
  yield takeLatest(types.GET_DAY_CUP_CALENDAR_CORRIERE_REQUEST, getDayCupCalendarCorriere);
}

function* watchGetTeamCalendar() {
  yield takeEvery(types.GET_TEAM_CALENDAR_REQUEST, getTeamCalendar);
}
function* watchGetGazzanetCalendar() {
  yield takeLatest(types.GET_CALENDAR_GAZZANET_REQUEST, getGazzanetCalendar);
}

function* watchGetRugbyTabbar() {
  yield takeLatest(types.GET_RUGBY_TABBAR_REQUEST, getRugbyTabbar);
}

function* watchGetRugbyCalendar() {
  yield takeLatest(types.GET_RUGBY_TABBAR_SUCCESS, getRugbyCalendar);
}

function* watchGetRugbyCalendarWithPhase() {
  yield takeLatest(types.GET_RUGBY_CALENDAR_REQUEST, getRugbyCalendarWithPhase);
}

export default [
  watchGetDayCalendar,
  watchGetCalendar,
  watchGetDayCalendarCorriere,
  watchGetCalendarCorriere,
  watchGetDayCupCalendarCorriere,
  watchGetCupCalendarCorriere,
  watchGetTeamCalendar,
  watchGetGazzanetCalendar,
  watchGetRugbyTabbar,
  watchGetRugbyCalendar,
  watchGetRugbyCalendarWithPhase,
];




// WEBPACK FOOTER //
// ./src/sagas/calendar.js